import * as ng from 'angular';
import {BaseUrlService} from '../../../services/base-url.service';
import {googleAPI} from '../../../third/googleAPI';
import {StorageService} from '../../../services/storage.service';
import {UserService} from '../../../services/user.service';
import {ArchiSmallServices} from '../../../services/archismall.service';
import {ValidationService} from '../../../services/validation.service';
import {appContext} from '../../../app.context';
import {VATService} from '../../../services/data/vat.service';

export class UserSettingsProfiloLPController implements ng.IController {
  static $inject: string[] = [
    '$rootScope',
    '$scope',
    '$state',
    'ArchiSmallServices',
    'store',
    '$uibModal',
    'BaseUrlService',
    'configuration',
    '$http',
    '$timeout',
    '$sce',
    '$parse',
    '$filter',
    'ValidationService',
    'StorageService',
    'UserService',
    'VATService'
  ];

  constructor(
    private $rootScope: any,
    private $scope: any,
    private $state: ng.ui.IStateService,
    private ArchiSmallServices: ArchiSmallServices,
    private store: ng.a0.storage.IStoreService,
    private $uibModal: ng.ui.bootstrap.IModalService,
    private baseUrlService: BaseUrlService,
    private configuration: any, // todo specificare il tipo
    private $http: ng.IHttpService,
    private $timeout: ng.ITimeoutService,
    private $sce: ng.ISCEService,
    private $parse: ng.IParseService,
    private $filter: ng.IFilterService,
    private ValidationService: ValidationService,
    private StorageService: StorageService,
    private UserService: UserService,
    private vatService: VATService
  ) {

    $scope.ivaItems = this.vatService.getItems();
    $scope.tooltips = {
      'header': `Completa, aggiorna o modificare le informazioni fornite durante la registrazione.\n
                La Ragione Sociale, la Partita IVA e il Codice Fiscale non possono essere modificati\n
                (in caso di errore contatta l'Assistenza). Le informazioni appariranno nella Fattura\n
                Elettronica che trasmetti con ArchiSMALL (es: Iscrizione REA, Albo Professionale, ecc)`,
      'disdici': 'Vuoi disdire il tuo abbonamento?',
      'securityQuestion': `Scegli una "Domanda di Sicurezza". Queste domande servono a verificare la tua identità o ad aiutarti a reimpostare la password.`,
      'customSecurityQuestion': `Crea la tua domanda di sicurezza personalizzata.`,
      'securityAnswer': `Scegli una "Risposta" alla tua "Domanda di Sicurezza". Servirà a verificare la tua identità o ad aiutarti a reimpostare la password nel caso la dimenticassi.`,
      'indirizzoPEC': `Facoltativo: inserisci l'indirizzo PEC (posta elettronica certificata) che usi per la tua azienda.`
    };

    $scope.CodiceDestinatarioType = new RegExp('^[A-Z0-9]{7}$');
    $scope.pageHeader = 'Impostazioni Utente';
    $scope.user = $scope.$parent.$resolve.user;
    store.set('user', $scope.user);
    $scope.identityCardMissing = $scope.user.organizationData.contactPerson.identityCardFile === '';

    $scope.securityQuestions = [
      'Domanda personalizzata',
      'Qual è la tua squadra del cuore?',
      'Qual è il nome del tuo cane?',
      'Qual è il nome del tuo gatto?',
      'Qual è la tua serie TV preferita?',
      'Gruppo musicale preferito?',
      'Qual è il cognome da nubile di tua madre/nonna?',
      'Qual è il nome della tua bisnonna?',
      'Qual è il nome del/della tua maestra/o o della scuola?',
      'Qual è il nome del tuo primo animale domestico?',
      'Qual è il tuo cibo preferito?',
      'Quale film non ti stancheresti mai di vedere?',
      'Qual è il tuo libro preferito?',
      'Qual è il nome del tuo eroe da bambino?'
    ];

    $scope.trustAsHtml = (value) => {
      return $sce.trustAsHtml(value);
    };

    let init = () => {
      if ($rootScope.user !== undefined) {
        if ($rootScope.user.accountData.userType !== 1) {
          $state.go('usersettings.gestione-profilo');
          return;
        }
      } else {
        setTimeout(init, 1000);
      }
    };
    init();
    $rootScope.formsubmitted = false;
    $scope.checkPassword = true;
    $scope.validEmail = true;
    $scope.validPEC = true;
    $scope.validNumbers = /^\d+$/;

    $scope.validateEmail = (email) => {


      if (email === null || email === '') {
        $scope.validEmail = true;
        return;
      }

      ArchiSmallServices.validateEmail(email)
        .then((response) => {
          $scope.validEmail = response;
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };
    $scope.validatePEC = (email) => {
      if (email === null || email === '') {
        $scope.validPEC = true;
        return;
      }

      ArchiSmallServices.validateEmail(email)
        .then((response) => {
          $scope.validPEC = response;
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };

    $scope.dpOpened = {
      periodStart: false,
      periodEnd: false,
      birthDate: false
    };
    $scope.openDP = ($event, opened) => {
      $event.preventDefault();
      $event.stopPropagation();
      $scope.dpOpened[opened] = true;
    };

    $scope.refreshSedeStates = () => {
      let country = $scope.user.organizationData.codicePaese;
      ArchiSmallServices.getTypeaheadValues('state', 'country=' + country)
        .then((response) => {
          $scope.sedeStates = response;
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };
    $scope.refreshStabileStates = () => {
      let country = $scope.user.organizationData.stabileOrganizzazione.codicePaese;
      ArchiSmallServices.getTypeaheadValues('state', 'country=' + country)
        .then((response) => {
          $scope.stabileStates = response;
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };
    $scope.refreshStateCodes = () => {
      let country = 'IT';
      ArchiSmallServices.getTypeaheadValues('stateCodes', 'country=' + country)
        .then((response) => {
          $scope.stateCodes = response;
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };
    $scope.refreshCities = () => {
      let country = $scope.user.organizationData.codicePaese;
      let state = $scope.user.organizationData.province;
      ArchiSmallServices.getTypeaheadValues('municipality', 'country=' + country + '&state=' + state)
        .then((response) => {
          $scope.cities = response;
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };
    $scope.refreshStabileCities = () => {
      let country = $scope.user.organizationData.stabileOrganizzazione.codicePaese;
      let state = $scope.user.organizationData.stabileOrganizzazione.province;
      ArchiSmallServices.getTypeaheadValues('municipality', 'country=' + country + '&state=' + state)
        .then((response) => {
          $scope.citiesStabile = response;
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };

    $scope.getCAP = () => {
      ArchiSmallServices.getTypeaheadValues('cap', 'state=' + $scope.user.organizationData.province + '&city=' + $scope.user.organizationData.city)
        .then((response) => {
          if (response[0] !== '') {
            $scope.user.organizationData.CAP = response[0];
          }
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };

    $scope.getStabileCAP = () => {
      ArchiSmallServices.getTypeaheadValues('cap', 'state=' + $scope.user.organizationData.stabileOrganizzazione.province + '&city=' + $scope.user.organizationData.stabileOrganizzazione.city)
        .then((response) => {
          if (response[0] !== '') {
            $scope.user.organizationData.stabileOrganizzazione.CAP = response[0];
          }
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };

    $scope.countries = ['Italy'];
    $scope.sedeStates = [];
    $scope.cities = [];
    $scope.callTypeaheadFunctions = () => {
      $scope.refreshSedeStates();
      $scope.refreshStabileStates();
      $scope.refreshStateCodes();
      $scope.refreshCities();
      $scope.refreshStabileCities();
    };
    $scope.regimeFiscaleValues = {
      'RF01': 'Ordinario',
      'RF02': 'Contribuenti minimi (art.1, c.96-117, L. 244/07)',
      'RF04': 'Agricoltura e attività connesse e pesca (artt.34 e 34-bis, DPR 633/72)',
      'RF05': 'Vendita sali e tabacchi (art.74, c.1, DPR. 633/72)',
      'RF06': 'Commercio fiammiferi (art.74, c.1, DPR 633/72)',
      'RF07': 'Editoria (art.74, c.1, DPR 633/72)',
      'RF08': 'Gestione servizi telefonia pubblica (art.74, c.1, DPR 633/72)',
      'RF09': 'Rivendita documenti di trasporto pubblico e di sosta (art.74, c.1, DPR 633/72)',
      'RF10': 'Intrattenimenti, giochi e altre attività di cui alla tariffa allegata al DPR 640/72 (art.74, c.6, DPR 633/72)',
      'RF11': 'Agenzie viaggi e turismo (art.74-ter, DPR 633/72',
      'RF12': 'Agriturismo (art.5, c.2, L. 413/91) ',
      'RF13': 'Vendite a domicilio (art.25-bis, c.6, DPR 600/73) ',
      'RF14': 'Rivendita beni usati, oggetti d’arte, d’antiquariato o da collezione (art.36, DL 41/95)',
      'RF15': 'Agenzie di vendite all’asta di oggetti d’arte, antiquariato o da collezione (art.40-bis, DL 41/95) ',
      'RF16': 'IVA per cassa P.A. (art.6, c.5, DPR 633/72) ',
      'RF17': 'IVA per cassa (art. 32-bis, DL 83/2012) ',
      'RF18': 'Altro',
      'RF19': 'Regime forfettario (art.1, c.54-89, L. 190/2014)',
      'RF20': 'Regime transfrontaliero di Franchigia IVA (Direttiva UE 2020/285)'
    };
    $scope.socioUnicoValues = {
      'SU': 'socio unico',
      'SM': 'più soci'
    };
    $scope.statoLiquidazioneValues = {
      'LS': 'in liquidazione',
      'LN': 'non in liquidazione'
    };
    $scope.countriesCodeValues = {
      'IT': 'Italy',
      'AF': 'Afghanistan',
      'AX': 'Åland Islands',
      'AL': 'Albania',
      'DZ': 'Algeria',
      'AS': 'American Samoa',
      'AD': 'Andorra',
      'AO': 'Angola',
      'AI': 'Anguilla',
      'AQ': 'Antarctica',
      'AG': 'Antigua and Barbuda',
      'AR': 'Argentina',
      'AM': 'Armenia',
      'AW': 'Aruba',
      'AU': 'Australia',
      'AT': 'Austria',
      'AZ': 'Azerbaijan',
      'BS': 'Bahamas',
      'BH': 'Bahrain',
      'BD': 'Bangladesh',
      'BB': 'Barbados',
      'BY': 'Belarus',
      'BE': 'Belgium',
      'BZ': 'Belize',
      'BJ': 'Benin',
      'BM': 'Bermuda',
      'BT': 'Bhutan',
      'BO': 'Bolivia, Plurinational State of',
      'BQ': 'Bonaire, Sint Eustatius and Saba',
      'BA': 'Bosnia and Herzegovina',
      'BW': 'Botswana',
      'BV': 'Bouvet Island',
      'BR': 'Brazil',
      'IO': 'British Indian Ocean Territory',
      'BN': 'Brunei Darussalam',
      'BG': 'Bulgaria',
      'BF': 'Burkina Faso',
      'BI': 'Burundi',
      'KH': 'Cambodia',
      'CM': 'Cameroon',
      'CA': 'Canada',
      'CV': 'Cape Verde',
      'KY': 'Cayman Islands',
      'CF': 'Central African Republic',
      'TD': 'Chad',
      'CL': 'Chile',
      'CN': 'China',
      'CX': 'Christmas Island',
      'CC': 'Cocos (Keeling) Islands',
      'CO': 'Colombia',
      'KM': 'Comoros',
      'CG': 'Congo',
      'CD': 'Congo, the Democratic Republic of the',
      'CK': 'Cook Islands',
      'CR': 'Costa Rica',
      'CI': 'Côte d\'Ivoire',
      'HR': 'Croatia',
      'CU': 'Cuba',
      'CW': 'Curaçao',
      'CY': 'Cyprus',
      'CZ': 'Czech Republic',
      'DK': 'Denmark',
      'DJ': 'Djibouti',
      'DM': 'Dominica',
      'DO': 'Dominican Republic',
      'EC': 'Ecuador',
      'EG': 'Egypt',
      'SV': 'El Salvador',
      'GQ': 'Equatorial Guinea',
      'ER': 'Eritrea',
      'EE': 'Estonia',
      'ET': 'Ethiopia',
      'FK': 'Falkland Islands (Malvinas)',
      'FO': 'Faroe Islands',
      'FJ': 'Fiji',
      'FI': 'Finland',
      'FR': 'France',
      'GF': 'French Guiana',
      'PF': 'French Polynesia',
      'TF': 'French Southern Territories',
      'GA': 'Gabon',
      'GM': 'Gambia',
      'GE': 'Georgia',
      'DE': 'Germany',
      'GH': 'Ghana',
      'GI': 'Gibraltar',
      'GR': 'Greece',
      'GL': 'Greenland',
      'GD': 'Grenada',
      'GP': 'Guadeloupe',
      'GU': 'Guam',
      'GT': 'Guatemala',
      'GG': 'Guernsey',
      'GN': 'Guinea',
      'GW': 'Guinea-Bissau',
      'GY': 'Guyana',
      'HT': 'Haiti',
      'HM': 'Heard Island and McDonald Islands',
      'VA': 'Holy See (Vatican City State)',
      'HN': 'Honduras',
      'HK': 'Hong Kong',
      'HU': 'Hungary',
      'IS': 'Iceland',
      'IN': 'India',
      'ID': 'Indonesia',
      'IR': 'Iran, Islamic Republic of',
      'IQ': 'Iraq',
      'IE': 'Ireland',
      'IM': 'Isle of Man',
      'IL': 'Israel',
      'JM': 'Jamaica',
      'JP': 'Japan',
      'JE': 'Jersey',
      'JO': 'Jordan',
      'KZ': 'Kazakhstan',
      'KE': 'Kenya',
      'KI': 'Kiribati',
      'KP': 'Korea, Democratic People\'s Republic of',
      'KR': 'Korea, Republic of',
      'KW': 'Kuwait',
      'KG': 'Kyrgyzstan',
      'LA': 'Lao People\'s Democratic Republic',
      'LV': 'Latvia',
      'LB': 'Lebanon',
      'LS': 'Lesotho',
      'LR': 'Liberia',
      'LY': 'Libya',
      'LI': 'Liechtenstein',
      'LT': 'Lithuania',
      'LU': 'Luxembourg',
      'MO': 'Macao',
      'MK': 'Macedonia, the Former Yugoslav Republic of',
      'MG': 'Madagascar',
      'MW': 'Malawi',
      'MY': 'Malaysia',
      'MV': 'Maldives',
      'ML': 'Mali',
      'MT': 'Malta',
      'MH': 'Marshall Islands',
      'MQ': 'Martinique',
      'MR': 'Mauritania',
      'MU': 'Mauritius',
      'YT': 'Mayotte',
      'MX': 'Mexico',
      'FM': 'Micronesia, Federated States of',
      'MD': 'Moldova, Republic of',
      'MC': 'Monaco',
      'MN': 'Mongolia',
      'ME': 'Montenegro',
      'MS': 'Montserrat',
      'MA': 'Morocco',
      'MZ': 'Mozambique',
      'MM': 'Myanmar',
      'NA': 'Namibia',
      'NR': 'Nauru',
      'NP': 'Nepal',
      'NL': 'Netherlands',
      'NC': 'New Caledonia',
      'NZ': 'New Zealand',
      'NI': 'Nicaragua',
      'NE': 'Niger',
      'NG': 'Nigeria',
      'NU': 'Niue',
      'NF': 'Norfolk Island',
      'MP': 'Northern Mariana Islands',
      'NO': 'Norway',
      'OM': 'Oman',
      'PK': 'Pakistan',
      'PW': 'Palau',
      'PS': 'Palestine, State of',
      'PA': 'Panama',
      'PG': 'Papua New Guinea',
      'PY': 'Paraguay',
      'PE': 'Peru',
      'PH': 'Philippines',
      'PN': 'Pitcairn',
      'PL': 'Poland',
      'PT': 'Portugal',
      'PR': 'Puerto Rico',
      'QA': 'Qatar',
      'RE': 'Réunion',
      'RO': 'Romania',
      'RU': 'Russian Federation',
      'RW': 'Rwanda',
      'BL': 'Saint Barthélemy',
      'SH': 'Saint Helena, Ascension and Tristan da Cunha',
      'KN': 'Saint Kitts and Nevis',
      'LC': 'Saint Lucia',
      'MF': 'Saint Martin (French part)',
      'PM': 'Saint Pierre and Miquelon',
      'VC': 'Saint Vincent and the Grenadines',
      'WS': 'Samoa',
      'SM': 'San Marino',
      'ST': 'Sao Tome and Principe',
      'SA': 'Saudi Arabia',
      'SN': 'Senegal',
      'RS': 'Serbia',
      'SC': 'Seychelles',
      'SL': 'Sierra Leone',
      'SG': 'Singapore',
      'SX': 'Sint Maarten (Dutch part)',
      'SK': 'Slovakia',
      'SI': 'Slovenia',
      'SB': 'Solomon Islands',
      'SO': 'Somalia',
      'ZA': 'South Africa',
      'GS': 'South Georgia and the South Sandwich Islands',
      'SS': 'South Sudan',
      'ES': 'Spain',
      'LK': 'Sri Lanka',
      'SD': 'Sudan',
      'SR': 'Suriname',
      'SJ': 'Svalbard and Jan Mayen',
      'SZ': 'Swaziland',
      'SE': 'Sweden',
      'CH': 'Switzerland',
      'SY': 'Syrian Arab Republic',
      'TW': 'Taiwan, Province of China',
      'TJ': 'Tajikistan',
      'TZ': 'Tanzania, United Republic of',
      'TH': 'Thailand',
      'TL': 'Timor-Leste',
      'TG': 'Togo',
      'TK': 'Tokelau',
      'TO': 'Tonga',
      'TT': 'Trinidad and Tobago',
      'TN': 'Tunisia',
      'TR': 'Turkey',
      'TM': 'Turkmenistan',
      'TC': 'Turks and Caicos Islands',
      'TV': 'Tuvalu',
      'UG': 'Uganda',
      'UA': 'Ukraine',
      'AE': 'United Arab Emirates',
      'GB': 'United Kingdom',
      'US': 'United States',
      'UM': 'United States Minor Outlying Islands',
      'UY': 'Uruguay',
      'UZ': 'Uzbekistan',
      'VU': 'Vanuatu',
      'VE': 'Venezuela, Bolivarian Republic of',
      'VN': 'Viet Nam',
      'VG': 'Virgin Islands, British',
      'VI': 'Virgin Islands, U.S.',
      'WF': 'Wallis and Futuna',
      'EH': 'Western Sahara',
      'YE': 'Yemen',
      'ZM': 'Zambia',
      'ZW': 'Zimbabwe'
    };

    $scope.phoneType = new RegExp('^[\u0000-\u007F]{5,12}$');
    $scope.PIVAType = new RegExp('^[A-Z0-9]{1,28}$');
    $scope.CodiceFiscaleType = new RegExp('^[A-Z0-9]{11,16}$');
    $scope.CAPType = new RegExp('^[0-9]{5}$');
    $scope.String20Type = new RegExp('^[\u0000-\u007F]{1,20}$');
    $scope.TitoloType = new RegExp('^[\u0000-\u007F]{2,10}$');
    $scope.CodEORIType = new RegExp('^.{13,17}$');
    $scope.String60LatinType = new RegExp('^[\u0000-\u00FF]{1,60}$');
    $scope.ProvinciaType = new RegExp('^[A-Z]{2}$');
    $scope.String60Type = new RegExp('^[\u0000-\u007F]{1,60}$');
    $scope.String80LatinType = new RegExp('^[\u0000-\u00FF]{1,80}$');
    $scope.String60LatinType = new RegExp('^[\u0000-\u00FF]{1,60}$');
    $scope.NumeroCivicoType = new RegExp('^[\u0000-\u007F]{1,8}$');

    $scope.getCurrentYearDate = () => {
      if ($scope.user.organizationData.periodiDiEsercizioAnnoSolare) {
        let currentYear = (new Date()).getFullYear();
        let start = new Date(currentYear, 0, 1);
        let end = new Date(currentYear, 11, 31);
        $scope.user.organizationData.periodStart = start;
        $scope.user.organizationData.periodEnd = end;
      } else {
        $scope.user.organizationData.periodStart = '';
        $scope.user.organizationData.periodEnd = '';
      }
    };

    $scope.openPasswordModal = (size) => {

      let changePasswordModal = $uibModal.open({
        animation: true,
        component: 'changePasswordComponent',
        size: size,
        windowClass: 'center-modal',
      });
    };

    $scope.openConfermaModal = (size) => {
      let ConfermaModal = $uibModal.open({
        animation: true,
        component: 'confermaComponent',
        size: size,
        windowClass: 'center-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          user: () => {
            return $scope.user;
          }
        }
      });
    };

    $scope.openChangePersonalFilesModal = (size) => {

      let ChangePersonalFilesModal = $uibModal.open({
        animation: true,
        component: 'changePersonalFilesComponent',
        size: size,
        windowClass: 'center-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          user: () => {
            return $scope.user;
          }
        }
      });

      ChangePersonalFilesModal.result.then((data) => {
        if (data.user !== undefined) {
          $scope.user = data.user;
          $scope.updatePersonalFiles(data);
        }

        if (data.requiredFieldsMissing !== undefined) {
          $scope.identityCardMissing = data.requiredFieldsMissing;
        }
      });
    };

    $scope.updatePersonalFiles = (data) => {
      $scope.files = {};
      if (data.changed.fiscalCode) {
        $scope.files.fiscalCode = {
          'fileName': $scope.user.organizationData.contactPerson.fiscalCodeFile,
          'fileId': $scope.user.organizationData.contactPerson.fiscalCodeFileId
        };
      }
      if (data.changed.identityCard) {
        $scope.files.identityCard = {
          'fileName': $scope.user.organizationData.contactPerson.identityCardFile,
          'fileId': $scope.user.organizationData.contactPerson.identityCardFileId
        };
      }
      if (data.changed.businessProfile) {
        $scope.files.businessProfile = {
          'fileName': $scope.user.organizationData.contactPerson.businessProfileFile,
          'fileId': $scope.user.organizationData.contactPerson.businessProfileFileId
        };
      }

      let promise = UserService.updatePersonalFiles($scope.files)
        .then((response) => {
          $scope.user = response;
          store.set('user', $scope.user);
        }, (error) => {
          $rootScope.alert('error', error);
        });
      return promise;
    };

    $scope.openUploadLogoModal = (size) => {

      let modalInstance = $uibModal.open({
        animation: true,
        component: 'uploadLogoModalComponent',
        controllerAs: 'vm',
        size: size,
        windowClass: 'center-modal',
        resolve: {
          user: $scope.user
        }
      });

      modalInstance.result.then((user) => {
        if (user !== undefined) {
          $scope.user = user;
          store.set('user', user);
        }
      });
    };

    $scope.emptyIfFieldChanged = (dependentModel1, dependentModel2, dependentModel3) => {
      $parse(dependentModel1).assign($scope, '');
      if (dependentModel2) {
        $parse(dependentModel2).assign($scope, '');
      }
      if (dependentModel3) {
        $parse(dependentModel3).assign($scope, '');
      }
    };

    $scope.dpOpened = {
      DataIscrizioneAlbo: false
    };
    $scope.openDP = ($event, opened) => {
      $event.preventDefault();
      $event.stopPropagation();
      $scope.dpOpened[opened] = true;
    };
    $scope.autoOpen = ($event, opened) => {
      /* tslint:disable:no-string-literal */
      if (appContext.userBrowser['isIE']) {
        return;
      }
      /* tslint:enable:no-string-literal */
      $event.preventDefault();
      $event.stopPropagation();
      $scope.dpOpened[opened] = true;
    };

    $scope.emptyInput = () => {
      $scope.oldInputValue = $scope.user.accountData.securityAnswer;
      $scope.user.accountData.securityAnswer = '';
      $scope.user.accountData.securityAnswer = '';
    };

    $scope.fillInput = () => {
      if ($scope.user.accountData.securityAnswer === '') {
        $scope.user.accountData.securityAnswer = $scope.oldInputValue;
        $scope.user.accountData.securityAnswer = $scope.oldInputValue;
      }
    };

    let initUserVar = () => {
      $scope.user.organizationData.contactPerson.birthDate = $rootScope.formatDateValue($scope.user.organizationData.contactPerson.birthDate);
      $scope.user.organizationData.periodStart = $rootScope.formatDateValue($scope.user.organizationData.periodStart);
      $scope.user.organizationData.periodEnd = $rootScope.formatDateValue($scope.user.organizationData.periodEnd);
      if ($scope.user.organizationData.codiceDestinatario && $scope.user.organizationData.codiceDestinatario.substring(0, 1) === '*') {
        $scope.user.organizationData.codiceDestinatario = 'ACTKBBZ';
      }
      if ($scope.user.organizationData.alboProfessionale !== undefined && $scope.user.organizationData.alboProfessionale.dataIscrizioneAlbo && $scope.user.organizationData.alboProfessionale.dataIscrizioneAlbo !== '') {
        $scope.user.organizationData.alboProfessionale.dataIscrizioneAlbo = $rootScope.formatDateValue($scope.user.organizationData.alboProfessionale.dataIscrizioneAlbo);
      }

      $scope.callTypeaheadFunctions();
    };

    initUserVar();

    $scope.validateCodiceDestinatario = (path, value) => {

      if (value === null || value === '') {
        $scope.validCodiceDestinatario = true;
        return;
      }
      ValidationService.validateUserFieldUniqueness(path, value)
        .then((response) => {
          $scope.validCodiceDestinatario = response;
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };

    $scope.startInputUpload = () => {
      $('#logo-upload').trigger('click');
    };

    $scope.inputUpload = (input) => {
      let file = input.files[0];
      let username = $scope.user.accountData.email;
      let dropzoneId = 'dropzone-logo';
      $scope.uploadFileOnGoogleStorage(file, username, dropzoneId);
    };

    let insertObject = (file, username, dropzoneId) => {
      let dropzoneStorageFolder = 'users/' + $scope.user.accountData.email + '/personal_files';
      ArchiSmallServices.validateGoogleAPIToken(googleAPI.getAccessToken())
        .then((response) => {
          googleAPI.insertObject(file, dropzoneId, dropzoneStorageFolder, username, $scope.uploadLogoFileOnGoogleStorageCallback);
          $rootScope.filesUploadedNumber++;
        }, (error) => {
          ArchiSmallServices.getGoogleAPIToken()
            .then((response: any) => {
              googleAPI.setAccessToken(response.accessToken);
              googleAPI.insertObject(file, dropzoneId, dropzoneStorageFolder, username, $scope.uploadLogoFileOnGoogleStorageCallback);
              $rootScope.filesUploadedNumber++;
            }, (error) => {
              $rootScope.alert('error', error);
            });
        });
    };

    $scope.uploadFileOnGoogleStorage = (file, username, dropzoneId) => {

      // user max upload size check
      if ((file.size / 1024 / 1024) > $scope.user.limits.maxFileSizeOnUploadMB) {
        $rootScope.alert('error', 'Il file ' + file.name + ' supera il limite di dimensione massimo consentito per l\'upload un singolo file (' + $scope.user.limits.maxFileSizeOnUploadMB + ' MB). Se desideri incrementare questo limite puoi contattare il supporto ArchiSMALL.');
        return;
      }

      // usage Percentage check
      ArchiSmallServices.getStorageUsage()
        .then((response: any) => {
          $rootScope.storageUsage = response;

          if (response.subscriptionCancelled) {
            $rootScope.alert('error', 'You can \'t upload files, because your subscription is cancelled');
            return;
          }

          if ($rootScope.storageUsage.usagePercentage >= 100 && $rootScope.storageUsage.isBlockUser) {
            $rootScope.alert('error', 'Hai esaurito lo spazio a disposizione (' + $rootScope.storageUsage.availableSpace + '). Richiedei un incremento di spazio contattando il supporto ArchiSMALL.');
            return;
          }

          insertObject(file, username, dropzoneId);
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };

    let getLogoBase64 = (logoStoragePath) => {
      StorageService.getBase64(logoStoragePath)
        .then((response) => {
          $scope.imagePreview = response.data;
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };

    $scope.uploadLogoFileOnGoogleStorageCallback = (dropzoneId, res, filename) => {
      let icon = '';
      let extension = filename.split('.').pop().toLowerCase();
      let delete_icon = '<a ng-click="vm.deleteFile($event)"><i class="fa fa-trash-o fa-lg"></i></a>';

      switch (extension) {
        case 'jpg':
        case 'png':
          icon = $sce.trustAsHtml('<i class="fa fa-file-image-o fa-lg"></i>');
          break;
        default:
          icon = $sce.trustAsHtml('<i class="fa fa-file-o fa-lg"></i>');
      }

      $scope.user.organizationData.logoStoragePath = res.id.split('/')[0] + '/' + res.name;
      $scope.logoFilename = filename;

      $scope.updateLogo();
    };

    $scope.updateLogo = () => {
      let promise = UserService.updateLogo($scope.user)
        .then((user) => {
          $scope.user = user;
          store.set('user', $scope.user);

          if (!$scope.logoIsEmpty()) {
            getLogoBase64($scope.user.organizationData.logoStoragePath);
          }
          initUserVar();
        }, (error) => {
          $rootScope.alert('error', error);
        });

      return promise;
    };

    let removeLogo = () => {
      let promise = UserService.removeLogo($scope.user)
        .then((user) => {
          $scope.user = user;
          store.set('user', $scope.user);
          initUserVar();
        }, (error) => {
          $rootScope.alert('error', error);
        });

      return promise;
    };

    $scope.logoIsEmpty = () => {
      return $scope.user.organizationData.logoStoragePath === '' ||
        $scope.user.organizationData.logoStoragePath === undefined;
    };

    if (!$scope.logoIsEmpty()) {
      getLogoBase64($scope.user.organizationData.logoStoragePath);
    }

    $scope.deleteLogo = () => {
      removeLogo();
      $scope.deleteInputFile();
    };

    $scope.deleteInputFile = () => {
      let element = ng.element(document.querySelector('#logo-upload'));
      ng.element(element).val(null);
    };

    $scope.openUnsubscribeMessageModal = (size) => {

      let UnsubscribeMessageModal = $uibModal.open({
        animation: true,
        component: 'unsubscribeMessageModalComponent',
        size: size,
        windowClass: 'center-modal',
        backdrop: 'static',
        keyboard: false
      });
    };

    $scope.openUnsubscribeModal = (size) => {

      let UnsubscribeModal = $uibModal.open({
        animation: true,
        component: 'unsubscribeModalComponent',
        size: size,
        backdrop: 'static',
        keyboard: false,
        windowClass: 'center-modal'
      });
      UnsubscribeModal.result.then((response) => {
        if (response) {
          ArchiSmallServices.unsubscribe($scope.user)
            .then((response) => { /* */
            }, (error) => {
              $rootScope.alert('error', error);
              $scope.cancel();
            });
        }
      });
    };
  }

}

export const UserSettingsProfiloLPComponent: ng.IComponentOptions = {
  template: require('./gestione-profilo-lp.html'),
  controller: UserSettingsProfiloLPController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/usersettings/gestione-profilo-lp/gestione-profilo-lp.ts